export const env = {
  API_SERVER: process.env.REACT_APP_DEV_API_SERVER || "http://localhost:1337",
};
